<template>
  <i class="stacked icons ml-1" :class="stateColorClass">
    <i id="circle" class="circle icon m-auto" />
    <i id="outline" class="circle outline icon" />
  </i>
</template>
<script>
/**
 * @description Composante générique pour les cercles de couleur d'état
 * @author Maxime Boisvert
 * @vue-prop {String|Number} state - L'état du cercle
 * @vue-computed {String} stateColorClass - Retourne la classe en fonction de l'état
 */
export default {
  name: "StateCircleColor",
  props: {
    state: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    stateColorClass() {
      return this.state == 2
        ? "text-danger"
        : this.state == 1
        ? "text-warning"
        : this.state == 0
        ? "text-success"
        : "text-light";
    }
  }
};
</script>
<style scoped>
#circle {
  font-size: 16px;
}

#outline {
  font-size: 24px;
}

#stacked {
  margin-left: 5px;
}
</style>
